module.exports = __webpack_public_path__ + "img/question-mark.8074a34e.svg";